// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/index.js!../../node_modules/.pnpm/less-loader@4.1.0_less@2.7.3_webpack@3.12.0/node_modules/less-loader/dist/cjs.js!./main.less");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../node_modules/.pnpm/style-loader@0.16.1/node_modules/style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/index.js!../../node_modules/.pnpm/less-loader@4.1.0_less@2.7.3_webpack@3.12.0/node_modules/less-loader/dist/cjs.js!./main.less", function() {
			var newContent = require("!!../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/index.js!../../node_modules/.pnpm/less-loader@4.1.0_less@2.7.3_webpack@3.12.0/node_modules/less-loader/dist/cjs.js!./main.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./layout/main.less
// module id = ./layout/main.less
// module chunks = 26